<template v-if="skin">
  <v-dialog v-model="show" width="350" persistent lazy>
    <v-card>
      <v-card-title>
        <v-flex grow>
          <h2 class="font-weight-light">{{ $t("Interchange.Title") }}</h2>
        </v-flex>
        <v-flex shrink>
          <v-btn gab icon small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <Interchange :input-only="true" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "InterchangeSearch",
  components: {
    Interchange: () => import("@/components/Interchange/Interchange"),

  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    })
  },
  methods: {
    close() {
      this.$root.$emit('close-modal', 'intSearch')
    }
  }
}
</script>